import React from 'react';

const LastProjectCard = ({ project }) => {
	return (
		<div className='col-12 col-md-6 col-xl-4'>
			<div className='background-secondary border-tertiary rounded-3 p-3'>
				<h5>{project.project_name}</h5>
				<p className='truncate-text'>{project.project_description}</p>
			</div>
		</div>
	);
};

export default LastProjectCard;
